// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"2b737986","858":"2b40b800"}[chunkId] + ".chunk.js";
};